export default {
  name: 'SipMovil',
  component: () =>
    import(
      /* webpackChunkName: "SipMovilLayout" */ "@/modules/SipMovil/layouts/SipMovilLayout.vue"
    ),
  redirect: "/SipMovil/empresas",
  children: [
    {
      path: "empresas",
      name: "empresas",
      component: () =>
        import(
          /* webpackChunkName: "empresas" */ "@/modules/SipMovil/pages/Empresas.vue"
        ),
    },
    {
      path: "servidores-asterisk",
      name: "servidores-asterisk",
      component: () =>
        import(
          /* webpackChunkName: "servidores-asterisk" */ "@/modules/SipMovil/pages/ServidoresAsterisk.vue"
        ),
    },
    {
      path: "servidores-jitsi",
      name: "servidores-jitsi",
      component: () =>
        import(
          /* webpackChunkName: "servidores-jitsi" */ "@/modules/SipMovil/pages/ServidoresJitsi.vue"
        ),
    },
    {
      path: "pre-translaciones",
      name: "pre-translaciones",
      component: () =>
        import(
          /* webpackChunkName: "pre-translaciones" */ "@/modules/SipMovil/pages/PreTranslaciones.vue"
        ),
    },
    {
      path: "almacenamiento",
      name: "almacenamiento",
      component: () =>
        import(
          /* webpackChunkName: "almacenamiento" */ "@/modules/SipMovil/pages/Almacenamiento.vue"
        ),
    },
    {
      path: "usuarios-admin",
      name: "usuarios-admin",
      component: () =>
        import(
          /* webpackChunkName: "usuarios-admin" */ "@/modules/SipMovil/pages/UsuariosAdmin.vue"
        ),
    },
    {
      path: "paises",
      name: "paises",
      component: () =>
        import(
          /* webpackChunkName: "paises" */ "@/modules/SipMovil/pages/Paises.vue"
        ),
    },
  ],
}
